import { render } from "./CreateAdminDialog.vue?vue&type=template&id=537485d1"
import script from "./CreateAdminDialog.vue?vue&type=script&lang=js"
export * from "./CreateAdminDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__